import React from 'react';
import { formatDateTime } from '../../utils';
import Command from '../../models/command';

interface CommandStateProps {
  command: Command;
}

export default function CommandState(props: CommandStateProps) {

  if (!props.command.operation)
    return <></>;

  let status = '';

  if (props.command.completed) {
    status = `Completed at ${formatDateTime(props.command.completed)}`;
  } else if (props.command.fetched) {
    status = `Fetched at ${formatDateTime(props.command.fetched)}`;
  } else {
    status = 'Pending...';
  }

  const byText = props.command.requested_by ? ` · by ${props.command.requested_by}` : '';

  let resultText = '';
  if (props.command.result) {
    const icon = props.command.success ? '✓' : '✗';
    resultText = ` ${icon} ${props.command.result}`;
  }

  return (
    <span
      title={`${props.command.operation}: ${status}${byText}${resultText}`}
      style={{
        backgroundColor: '#533c3c',
        padding: '4px 8px',
        borderRadius: '4px',
        border: '1px solid rgba(0,0,0,0.1)',
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%'
      }}>
      <span style={{ fontWeight: 'medium' }}>{props.command.operation}</span>: {status}
      {byText && <span style={{ opacity: 0.7 }}>{byText}</span>}
      {resultText && (
        <span style={{
          marginLeft: '8px',
          color: props.command.success ? '#3ac741' : '#ff7e7e'
        }}>
          {resultText}
        </span>
      )}
    </span>
  );
}